import _ from 'lodash';

import { User, WorkspaceResource } from '@skinsoft/types';

export const fullName = (user: User) => `${user.firstName} ${user.lastName}`;
export const shortName = (user: User) => {
    const firstName = user.firstName;
    const lastName = user.lastName;

    if (firstName && lastName) {
        return `${user.firstName} ${user.lastName.slice(0, 1)}.`;
    }

    if (firstName && !lastName) {
        return firstName;
    }

    if (!firstName && lastName) {
        return lastName;
    }

    return user.username;
}

export const defaultInterfaceLanguage = (user: User) => _.get(user, 'defaultInterfaceLanguage')
export const defaultDataLanguage = (user: User) => _.get(user, 'defaultDataLanguage')

export const principalWorkspace = (user: User): WorkspaceResource | undefined | null => {
    return _.get(user, 'workspaceMenuResource.principalWorkspace')
}

export const userWorkspaces = (user: User): WorkspaceResource[] | null | undefined => {
    return _.get(user, 'workspaceMenuResource.workspaces').concat(
        _.get(user, 'workspaceMenuResource.workspaceMenus').map(menu => menu.workspaces).flat()
    )
}

export const defaultWorkspace = (user: User): WorkspaceResource | null => {
    const principal = principalWorkspace(user)
    if(principal) {
        return principal
    }

    const workspaces = userWorkspaces(user)
    if(workspaces?.length) {
        return workspaces[0]
    }

    return null
} 